import styled from "styled-components";

export const ButtonStyled = styled.div`
    display: flex;
    padding: 10px;
    color: ${props => props.theme.layouts.mainLayout.header.toolButton.iconColor};
    cursor: pointer;
    background-color: ${props => props.theme.layouts.mainLayout.header.toolButton.bgColor};
    border: 1px;
    border-radius: 6px;
    transition: all 0.2s ease-in;

    &:hover {
        color: ${props => props.theme.layouts.mainLayout.header.toolButton.hoverIconColor};
        background-color: ${props => props.theme.layouts.mainLayout.header.toolButton.hoverBgColor};
    }    
`;
